"use client";

import { MousePointer2 } from "lucide-react";
import { useEffect, useState } from "react";
import { HomeBrandLogo } from "@/components/task/home-brand-logo";
import { AppLink } from "@/lib/navigation";
import { HomeIllustration } from "@/components/task/home-illustration";
import { HomeHeroIllustration } from "@/components/task/home-hero-illustration";
import { useSidebar } from "@/components/ui/sidebar";
import { getWelcomeMessage } from "./welcome-message";
import "./home.css";

export default function TaskListPage() {
  const [welcomeMessage, setWelcomeMessage] = useState(() => getWelcomeMessage(new Date()));

  useEffect(() => {
    const refresh = () => setWelcomeMessage(getWelcomeMessage(new Date()));
    const timer = window.setInterval(refresh, 60_000);
    window.addEventListener("focus", refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  const { isMobile, setOpen, setOpenMobile } = useSidebar();
  const closeSidebar = () => {
    if (isMobile) {
      setOpenMobile(false);
    } else {
      setOpen(false);
    }
  };

  return (
    <div className="min-h-full bg-neutral-50/40 px-6 pb-12 pt-20 sm:px-10 lg:px-16">
      <section aria-labelledby="welcome-heading" className="home-welcome mx-auto max-w-6xl">
        <div className="home-hero">
          <div>
            <HomeBrandLogo />
            <h1 id="welcome-heading" className="text-4xl font-semibold leading-[1.12] tracking-tight text-neutral-950 sm:text-5xl xl:text-6xl">
              Todo empieza con alguien.<br />
              <span className="text-neutral-500">{welcomeMessage}</span>
            </h1>
          </div>
          <div className="home-hero-art"><HomeHeroIllustration /></div>
        </div>
        <nav aria-label="Accesos a procesos" className="home-accesses">
          <AppLink href="/task-list/start-process" prefetch={false} onClick={closeSidebar} className="home-access home-access--process">
            <HomeIllustration kind="process" /><span>Iniciar un proceso</span>
          </AppLink>
          <AppLink href="/task-list/tasks" prefetch={false} onClick={closeSidebar} className="home-access home-access--tasks">
            <HomeIllustration kind="tasks" /><span>Mis tareas</span>
          </AppLink>
          <AppLink href="/task-list/participated" prefetch={false} onClick={closeSidebar} className="home-access home-access--history">
            <HomeIllustration kind="history" /><span>Histórico</span>
          </AppLink>
        </nav>
        <MousePointer2 aria-hidden="true" className="home-tour-cursor" size={32} strokeWidth={1.5} />
      </section>
    </div>
  );
}
